import * as R from 'ramda';
import { ActionType } from '../../../core/redux/actionType';
import { makeApiAction, makeRsaaTypes, ApiReducer, makeApiReducer } from '../../../core/api/rsaa';
import { Endpoints } from '../../../core/api/endpoints';
import { getLoading, addLoading, addError, noLoadingNoError } from '../../../core/api/module';
import { AppState } from '../../../core/redux/appState';


const KEY_ACTION = ActionType.CreateSecurityChallengeRequest;
const ACTIONS    = [
  ActionType.CreateSecurityChallengeRequest,
  ActionType.CreateSecurityChallengeResponse,
  ActionType.CreateSecurityChallengeError,
];


type Payload = string;

type Meta = {
  securityQuestionId: number;
  securityAnswer: string;
}


/**
 * Dispatch this action to set a new security question/answer pair for the current user.
 * TODO: implement hashing once hashed answers are by the API
 *
 * @param questionId The database Id of the question selected by the user
 * @param answer A cryptographically hashed representation of the user's answer to their security question
 */
export const createSecurityChallengeAction = (
  questionId: number,
  answer: string,
) => makeApiAction<Payload, Meta>({
  method:   'POST',
  endpoint: Endpoints.UpdateSecurityQuestion,
  headers:  { 'content-type': 'application/json' },
  body:     (state: AppState) => JSON.stringify({
    userId:     state.auth.currentUser?.userId,
    questionId: questionId,
    answer:     answer,
  }),
  types:    makeRsaaTypes<Payload, Meta>(ACTIONS, { securityQuestionId: questionId, securityAnswer: answer }),
  bailout:  state => !!getLoading(state, KEY_ACTION),
});


const reducer: ApiReducer<Payload, Meta> = (state, action, errorMsg, isLoading, payload) => {
  if (isLoading) {
    return addLoading(state, KEY_ACTION);
  }

  if (errorMsg) {
    return addError(state, KEY_ACTION, errorMsg);
  }

  const successState = noLoadingNoError(state, KEY_ACTION);

  return R.assocPath(
    ['auth', 'currentUser', 'securityQuestionId'],
    action.meta.securityQuestionId,
    R.assocPath(['auth', 'currentUser', 'securityAnswer'], action.meta.securityAnswer, successState),
  );
};


export const createSecurityChallengeReducer = makeApiReducer<Payload, Meta>(ACTIONS, KEY_ACTION, reducer);
